import createIcon from '../../createIcon';

/**
 * @component @name Subscript
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNTYwNCAxOEgxNy41NjA0VjE5SDIwLjU2MDRWMjBIMTYuNTYwNFYxOEMxNi41NjA0IDE3LjQ1IDE3LjAxMDQgMTcgMTcuNTYwNCAxN0gxOS41NjA0VjE2SDE2LjU2MDRWMTVIMTkuNTYwNEMyMC4xMTA0IDE1IDIwLjU2MDQgMTUuNDUgMjAuNTYwNCAxNlYxN0MyMC41NjA0IDE3LjU1IDIwLjExMDQgMTggMTkuNTYwNCAxOFpNMy40NDA0MyAxOEg2LjEwMDQzTDkuNTAwNDMgMTIuNThIOS42MjA0M0wxMy4wMjA0IDE4SDE1LjY4MDRMMTEuMDMwNCAxMC43M0wxNS4zNzA0IDRIMTIuNjkwNEw5LjYyMDQzIDguOTlIOS41MDA0M0w2LjQxMDQzIDRIMy43NTA0M0w4LjA3MDQzIDEwLjczTDMuNDQwNDMgMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Subscript = createIcon('Subscript', [
  [
    'path',
    {
      d: 'M19.5604 18H17.5604V19H20.5604V20H16.5604V18C16.5604 17.45 17.0104 17 17.5604 17H19.5604V16H16.5604V15H19.5604C20.1104 15 20.5604 15.45 20.5604 16V17C20.5604 17.55 20.1104 18 19.5604 18ZM3.44043 18H6.10043L9.50043 12.58H9.62043L13.0204 18H15.6804L11.0304 10.73L15.3704 4H12.6904L9.62043 8.99H9.50043L6.41043 4H3.75043L8.07043 10.73L3.44043 18Z',
      key: '19bbfq',
    },
  ],
]);

export default Subscript;
